import type { CatalogProduct } from '../types'

type ArtworkProps = {
  product?: CatalogProduct
  tone?: CatalogProduct['tone']
  className?: string
  label?: string
}

export function Artwork({ product, tone, className = '', label }: ArtworkProps) {
  const artworkTone = product?.tone || tone || 'dawn'
  const description = label || product?.name || 'MUDAII visual'

  if (product?.imageUrl) {
    return (
      <div className={'artwork artwork--photo ' + className} role="img" aria-label={description}>
        <img alt={description} src={product.imageUrl} />
      </div>
    )
  }

  return (
    <div
      aria-label={description}
      className={'artwork artwork--' + artworkTone + ' ' + className}
      role="img"
    >
      <span className="artwork__sun" />
      <span className="artwork__stem" />
      <span className="artwork__form">
        <i />
        <i />
        <i />
      </span>
      <span className="artwork__shadow" />
    </div>
  )
}
